/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-body[_ngcontent-%COMP%]{text-align:left}label[_ngcontent-%COMP%]{font-weight:700;margin:0}"];
export { styles as styles };
